// removed by extract-text-webpack-plugin
module.exports = {"header":"Header-style__header__o-Fyi","title":"Header-style__title__UFFvM","close":"Header-style__close__3l0ks","closeButton":"Header-style__closeButton__1Cpty"};


//////////////////
// WEBPACK FOOTER
// ./assets/js/global/views/modal/Header-style.scss
// module id = 1485
// module chunks = 64